import { initializeH5RequestFromHeader } from '@h5-journey/bootstrap'
import { isInApp, isInHostMiniAppWebView } from '@h5-journey/utils'
import axios from 'axios'

// APP、小程序与元服务保留 main.js 的来源，不注册 H5 拦截器。
if (initializeH5RequestFromHeader('legacy-app')) {
  axios.interceptors.request.use(config => {
    // 宿主能力可能晚于入口识别；发请求时再确认，避免接管原生来源。
    if (isInApp() || isInHostMiniAppWebView()) return config
    const requestFrom = sessionStorage.getItem('Request-From')
    if (requestFrom) config.headers['Request-From'] = requestFrom
    return config
  })
}
